import { AuthStore } from '@/stores/authStore';
import { determineNavItems } from '@/utils/permissions/permissions-utils';
import type { NavItemDefinition } from '@scu/core-ui/dist/types/components/scu-top-bar/types';
import { computed, type ComputedRef } from 'vue';
import { ComposerTranslation } from 'vue-i18n';

export function getNavBarItems(t: ComposerTranslation, authStore: AuthStore): ComputedRef<NavItemDefinition[]> {
  // bestimmung der sichtbaren Navigationspunkte in der Top-Bar abhängig von den Berechtigungen der aktuellen User-Rolle
  return computed(() => determineNavItems(authStore, t));
}
